@if (config) {
  <a [routerLink]="config.route"
     [class]="config.buttonClass">
    <span class="d-none d-sm-inline">{{ config.label }}</span>
    <span class="ms-sm-1 badge text-bg-light rounded-pill">{{ count() }}</span>
    <span class="visually-hidden">{{ config.ariaLabel }}</span>
  </a>
}